import React, { createContext, useCallback, useContext, useRef } from 'react';

const ListScrollCacheContext = createContext({
  get: () => null,
  set: () => {},
  clear: () => {},
});

export function ListScrollCacheProvider({ children }) {
  const cacheRef = useRef({});

  const get = useCallback((key) => cacheRef.current[key] || null, []);
  const set = useCallback((key, value) => {
    cacheRef.current[key] = value;
  }, []);
  const clear = useCallback((key) => {
    if (key) delete cacheRef.current[key];
    else cacheRef.current = {};
  }, []);

  return (
    <ListScrollCacheContext.Provider value={{ get, set, clear }}>
      {children}
    </ListScrollCacheContext.Provider>
  );
}

export function useListScrollCache() {
  return useContext(ListScrollCacheContext);
}
